export const initialState = {
    isAddNewNote:false,
  };
  